"use client";

import React from "react";
import { usePermission } from "@/hooks";

const PermissionDebugger: React.FC = () => {
  const { isSuperAdmin, isOwner, session, loading } = usePermission();

  if (loading) {
    return <div className="p-4 border rounded">⏳ Carregando sessão...</div>;
  }

  return (
    <div className="p-4 border rounded-lg bg-gray-50 max-w-4xl mx-auto my-4">
      <h2 className="text-xl font-bold mb-4">🔍 Debug de Permissões</h2>

      <div className="space-y-4">
        <div className="p-3 bg-white rounded border">
          <h3 className="font-semibold text-lg mb-2">📊 Status</h3>
          <p>
            <strong>isSuperAdmin:</strong>{" "}
            <span
              className={
                isSuperAdmin() ? "text-green-600 font-bold" : "text-red-600"
              }
            >
              {isSuperAdmin().toString()}
            </span>
          </p>
          <p>
            <strong>isOwner:</strong>{" "}
            <span
              className={
                isOwner() ? "text-green-600 font-bold" : "text-red-600"
              }
            >
              {isOwner().toString()}
            </span>
          </p>
        </div>

        <div className="p-3 bg-white rounded border">
          <h3 className="font-semibold text-lg mb-2">🗂️ Estrutura da Sessão</h3>
          <pre className="text-xs bg-gray-100 p-2 rounded overflow-auto max-h-96">
            {JSON.stringify(session, null, 2)}
          </pre>
        </div>

        <div className="p-3 bg-white rounded border">
          <h3 className="font-semibold text-lg mb-2">👤 Dados do Usuário</h3>
          <div className="text-sm space-y-1">
            <p>
              <strong>session.user:</strong>{" "}
              {session?.user ? "✅ Existe" : "❌ Não existe"}
            </p>
            <p>
              <strong>session.user.user:</strong>{" "}
              {session?.user?.user ? "✅ Existe" : "❌ Não existe"}
            </p>

            {session?.user && (
              <div className="ml-4 mt-2">
                <p>
                  <strong>session.user.is_super_admin:</strong>{" "}
                  {session.user.is_super_admin?.toString() || "undefined"}
                </p>
                <p>
                  <strong>session.user.is_owner:</strong>{" "}
                  {session.user.is_owner?.toString() || "undefined"}
                </p>
                <p>
                  <strong>session.user.roles:</strong>{" "}
                  {session.user.roles
                    ? JSON.stringify(session.user.roles)
                    : "undefined"}
                </p>
                <p>
                  <strong>session.user.permissions:</strong>{" "}
                  {session.user.permissions
                    ? JSON.stringify(session.user.permissions)
                    : "undefined"}
                </p>
              </div>
            )}

            {session?.user?.user && (
              <div className="ml-4 mt-2">
                <p>
                  <strong>session.user.user.is_super_admin:</strong>{" "}
                  {session.user.user.is_super_admin?.toString() || "undefined"}
                </p>
                <p>
                  <strong>session.user.user.is_owner:</strong>{" "}
                  {session.user.user.is_owner?.toString() || "undefined"}
                </p>
                <p>
                  <strong>session.user.user.roles:</strong>{" "}
                  {session.user.user.roles
                    ? JSON.stringify(session.user.user.roles)
                    : "undefined"}
                </p>
                <p>
                  <strong>session.user.user.permissions:</strong>{" "}
                  {session.user.user.permissions
                    ? JSON.stringify(session.user.user.permissions)
                    : "undefined"}
                </p>
              </div>
            )}
          </div>
        </div>

        <div className="p-3 bg-white rounded border">
          <h3 className="font-semibold text-lg mb-2">💡 Instruções</h3>
          <ol className="text-sm space-y-1 list-decimal list-inside">
            <li>Verifique a estrutura da sessão acima</li>
            <li>
              Configure <code>is_super_admin: true</code> no objeto correto
            </li>
            <li>
              Ou adicione role com <code>slug: "super_admin"</code>
            </li>
            <li>
              Ou adicione <code>"super_admin"</code> no array de permissions
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default PermissionDebugger;
